import React from 'react'
import { Group, Circle, Text } from 'react-konva'
import { toScale, fromScale } from '../../../lib/canvas-math.js'

const ORDINAL_LABELS = ['1.', '2.', '3.', '4.', '5.', '6.', '7.', '8.']
const STROKE = '#E63946'

/**
 * Tek sürüklenebilir deneme alanı: içi boş, kırmızı çerçeve.
 * Hangi alan (1.-8.) seçiliyse o numara ile etiketlenir.
 */
const DraggableAreaOverlay = ({
    areaNumber,
    x,
    y,
    radius,
    mapSize,
    pubgMapSize,
    mapScale,
    onPositionChange,
    onDragStartCallback,
    onDragEndCallback,
}) => {
    const layerX = toScale(pubgMapSize, mapSize, x)
    const layerY = toScale(pubgMapSize, mapSize, y)
    const layerRadius = toScale(pubgMapSize, mapSize, radius)

    const stopStageDrag = (e) => {
        if (e.evt) {
            e.evt.stopPropagation()
        }
    }

    const handleDragStart = () => {
        if (onDragStartCallback) onDragStartCallback()
    }

    const handleDragEnd = (e) => {
        const node = e.target
        const newLayerX = node.x()
        const newLayerY = node.y()
        const newX = fromScale(pubgMapSize, mapSize, newLayerX)
        const newY = fromScale(pubgMapSize, mapSize, newLayerY)
        onPositionChange(newX, newY)
        if (onDragEndCallback) onDragEndCallback()
    }

    return (
        <Group
            x={layerX}
            y={layerY}
            draggable
            onPointerDown={stopStageDrag}
            onDragStart={(e) => { stopStageDrag(e); handleDragStart(); }}
            onDragEnd={handleDragEnd}
            listening={true}
        >
            <Circle
                x={0}
                y={0}
                radius={layerRadius}
                fill="transparent"
                stroke={STROKE}
                strokeWidth={Math.max(1, 2 / mapScale)}
                listening={true}
            />
            <Text
                x={-layerRadius}
                y={-8}
                width={layerRadius * 2}
                text={ORDINAL_LABELS[areaNumber - 1] || String(areaNumber)}
                fontSize={14}
                fontStyle="bold"
                fill={STROKE}
                align="center"
                listening={false}
            />
        </Group>
    )
}

export default DraggableAreaOverlay



// WEBPACK FOOTER //
// ./src/components/MatchPlayer/Map/DraggableAreaOverlay.js